﻿export namespace PermissionKeys {
    export const ManageSettings = "SystemAdmin:ClientSettings";
    export const ResetCaches = "SystemAdmin:ResetCaches";
    export const ResetHealthDashboardCache = "SystemAdmin:ResetHealthDashboardCache";
}